import React from 'react';

interface PageSizeSelectorProps {
  pageSize: number;
  onPageSizeChange: (size: number) => void;
  options?: number[];
  disabled?: boolean;
}

const PageSizeSelector: React.FC<PageSizeSelectorProps> = ({
  pageSize,
  onPageSizeChange,
  options = [5, 10, 15, 20, 50, 100],
  disabled = false,
}) => {
  return (
    <div
      className="
      flex
      flex-col

      gap-1

      sm:flex-row
      sm:items-center
      sm:gap-3
    "
    >
      {/* 🧾 Label */}
      <span
        className="
        text-[11px]
        font-semibold
        uppercase
        tracking-wide

        text-body

        dark:text-bodydark2
      "
      >
        Entradas por página
      </span>

      {/* ⬇️ Selector */}
      <div className="relative min-w-[100px]">
        <select
          value={pageSize}
          onChange={(e) => onPageSizeChange(Number(e.target.value))}
          disabled={disabled}
          className={`
          h-[42px]

          w-full

          appearance-none

          rounded-xl
          border

          border-stroke

          bg-white

          pl-4
          pr-10

          text-sm
          font-medium

          text-black

          outline-none

          transition-all
          duration-200

          hover:border-primary

          focus:border-primary
          focus:ring-2
          focus:ring-primary/10

          dark:border-strokedark
          dark:bg-meta-4
          dark:text-white

          ${
            disabled
              ? `
                cursor-not-allowed
                opacity-50
              `
              : ''
          }
        `}
        >
          {options.map((size) => (
            <option
              key={size}
              value={size}
              className="
              bg-white
              text-black

              dark:bg-boxdark
              dark:text-white
            "
            >
              {size}
            </option>
          ))}
        </select>

        {/* ⬇️ Arrow */}
        <div
          className="
          pointer-events-none

          absolute
          right-3
          top-1/2

          -translate-y-1/2

          text-body

          dark:text-bodydark2
        "
        >
          <svg
            width="18"
            height="18"
            viewBox="0 0 18 18"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M9.0002 12.8249C8.83145 12.8249 8.69082 12.7687 8.5502 12.6562L2.08145 6.2999C1.82832 6.04678 1.82832 5.65303 2.08145 5.3999C2.33457 5.14678 2.72832 5.14678 2.98145 5.3999L9.0002 11.278L15.0189 5.34365C15.2721 5.09053 15.6658 5.09053 15.9189 5.34365C16.1721 5.59678 16.1721 5.99053 15.9189 6.24365L9.45019 12.5999C9.30957 12.7405 9.16895 12.8249 9.0002 12.8249Z"
              fill="currentColor"
            />
          </svg>
        </div>
      </div>
    </div>
  );
};

export default PageSizeSelector;
